/**
 * Typed wrappers for the customer-facing slice of /api/v1/billing/*.
 *
 * Read-only by design (for now). Mutating operations (Checkout,
 * Portal, Cancel, Resume) live behind the admin-ui's CSRF-aware
 * client - platform-ui hasn't grown CSRF plumbing yet (see
 * platform-ui/src/api/client.ts header). The Plan modal in the
 * dashboard reads tier + usage from /me and links users over to
 * /admin/billing for any actions.
 *
 * If a future PR adds CSRF to platform-ui, this module can grow the
 * Stripe POST verbs without changing the existing read calls.
 */
import { api } from './client';

export type MeterId = 'documents_indexed' | 'platform_users' | 'widgets';

export interface QuotaEntry {
  used: number;
  limit: number | null;
  remaining: number | null;
  unlimited: boolean;
  over_limit: boolean;
  source: 'tier' | 'override';
}

export interface TierSnapshot {
  id: string;
  display_name: string;
  description: string;
  price_monthly_minor: number;
  currency: string;
  limits: Partial<Record<MeterId, number | null>>;
  features: string[];
  sort_order: number;
  stripe_lookup_key: string | null;
  trial_days: number | null;
  hidden: boolean;
}

export interface SubscriptionSnapshot {
  status: string;
  current_period_start: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
}

export interface BillingSnapshot {
  client_id: string;
  tier: TierSnapshot;
  subscription: SubscriptionSnapshot;
  usage: Record<MeterId, number>;
  quota: Record<MeterId, QuotaEntry>;
  override: unknown;
  features: string[];
}

export function getBillingMe(): Promise<BillingSnapshot> {
  return api<BillingSnapshot>('/api/v1/billing/me');
}
